import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { GET_TALENT } from '@gql/talents';

export const useGetTalent = (talentId: string) => {
    const { isUpercut } = useAuth();

    const { data, loading, error, refetch } = useQuery(GET_TALENT, {
        variables: { talentId },
        skip: !isUpercut,
    });

    if (!isUpercut) {
        return { talent: null, loading: false, error: null, refetch: () => { } };
    }

    return {
        talent: data?.getTalent,
        loading,
        error,
        refetch,
    };
};
